import { IButtonRowItem, getUrl } from "lib/types/sanity";
import Link from "next/link";
import styles from "./ButtonRow.module.css";


//#region [Props]
type ButtonRowProps = {
    buttonrowItems?: IButtonRowItem[];
};
//#endregion



//#region [Component]
export default function ButtonRow({ buttonrowItems }: ButtonRowProps) {
    if ((buttonrowItems?.length ?? 0) === 0) {
        return null;
    }
    return <nav className={styles.ButtonRow}>
        {buttonrowItems?.map(item => {
            const url = getUrl(item);
            if (!url) {
                return null;
            }
            return <Link key={item._key} href={url}>{item.title}</Link>;
        })}
    </nav>
}
//#endregion